import {
  floatingImagesVariants,
  FloatingImagesVariantProps,
} from "./floating-images.variants";

export type UseFloatingImagesProps = FloatingImagesVariantProps & {
  className?: string;
  style?: Record<string, string | number>;
  images: {
    id: string;
    src: string;
    depth: number;
    className?: string;
    wrapperClassName?: string;
    width: number;
    height: number;
  }[];
};

export const useFloatingImages = (props: UseFloatingImagesProps) => {
  const { className = "", ...rest } = props;

  const styles = floatingImagesVariants();

  return {
    className,
    styles,
    ...rest,
  };
};
